import { ActivityType } from "@tandemdiabetes/sugarmate-api-react-client"
import { ModalBody } from "@tandemdiabetes/sugarmate-react-components"

import { useEntryModalPrivateContext } from "./EntryModalPrivateContext"
import { SubEntryFooter } from "./SubEntryFooter"
import { SubEntryHeader } from "./SubEntryHeader"
import styles from "src/styles/entryModal.module.scss"
import type {
  EditableSubEntry,
  EditableUserEntry,
} from "src/types"

interface Props {
  currentSubEntry: EditableSubEntry<ActivityType.Note>;
  updateSubEntry: (s: Partial<EditableSubEntry<ActivityType.Note>>) => void;
  currentUserEntry: EditableUserEntry;
  setCurrentUserEntry: (userEntry: EditableUserEntry) => void;
}

export function NoteForm(props: Props) {
  const {
    currentSubEntry,
    updateSubEntry,
    currentUserEntry,
    setCurrentUserEntry,
  } = props

  const { readOnly } = useEntryModalPrivateContext()

  return (
    <>
      <SubEntryHeader
        activityType={ActivityType.Note}
        currentSubEntry={currentSubEntry}
        currentUserEntry={currentUserEntry}
        setCurrentUserEntry={setCurrentUserEntry}
        readOnly={readOnly}
        closeBtnId="note-entry-close-btn"
      />
      <ModalBody className={styles.modalBody}>
        <SubEntryFooter
          currentSubEntry={currentSubEntry}
          currentUserEntry={currentUserEntry}
          updateSubEntry={updateSubEntry}
          readOnly={readOnly}
        />
      </ModalBody>
    </>
  )
}
